import { render } from "./passed.vue?vue&type=template&id=591372d8&scoped=true"
import script from "./passed.vue?vue&type=script&lang=js"
export * from "./passed.vue?vue&type=script&lang=js"

import "./passed.vue?vue&type=style&index=0&id=591372d8&lang=less&scoped=true"

import exportComponent from "D:\\workday\\code\\h5-moxigecash\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591372d8"]])

export default __exports__